import * as React from 'react'

const ArrowRight = (props: { className?: string; height?: number; width?: number; fill?: string }) => (
  <svg {...props} viewBox='0 0 7 12' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.30577 0.102215L6.87885 5.68995C7.04038 5.85349 7.04038 6.12606 6.87885 6.28961L1.30577 11.8773C1.14423 12.0409 0.875 12.0409 0.713462 11.8773L0.121154 11.2777C-0.0403846 11.1141 -0.0403846 10.8416 0.121154 10.678L4.50962 6.28961C4.67115 6.12606 4.67115 5.85349 4.50962 5.68995L0.148077 1.30153C-0.0134615 1.13799 -0.0134615 0.865417 0.148077 0.701874L0.740385 0.102215C0.901923 -0.0340719 1.14423 -0.0340719 1.30577 0.102215Z'
    />
  </svg>
)

export default ArrowRight



// WEBPACK FOOTER //
// ./src/components/icons/ui/ArrowRight.tsx